// extracted by mini-css-extract-plugin
export var externalLink = "_bd-0";
export var internalLinkLabel = "_bd-1";